<template>
    <div class="download bg_gray">
        <div class="download__inner container flex column">
            <h2 class="f-24 bold uppercase wc-lg">{{ _.get(this.contentData, 'conf.header.title') }}</h2>
                <div class="download__rows flex column wc-lg">
                    <DownloadRow :row_data="row" v-for=" (row, index ) in content" :key="index" />
      

                </div>
        </div>
    </div>
</template>

<script>
import DownloadRow from "@/components/modules/DownloadRow";
export default {
    props: ['contentData'], 
    components: {DownloadRow},
    computed: {
        content(){
            return _.get(this.contentData, 'data.list')
        }
    }
}
</script>

<style>

</style>